import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";
import PopupHubspot from "~/vue/organisms/popups/PopupHubspot.vue";

interface Props {
	portalId: string;
	formId: string;
	size?: string;
	prePopulatedFields?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonHubspot',
  props: {
    portalId: {},
    formId: {},
    size: { default: "small" },
    prePopulatedFields: {}
  },
  setup(__props: any) {

const props = __props;

const showPopup = ref(false);

const onShowPopup = () => {
	showPopup.value = true;
};

const onHidePopup = () => {
	showPopup.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ButtonSecondary, {
      type: "button",
      size: __props.size,
      icon: "envelope",
      ga: {
				category: 'form',
				action: 'show',
				label: __props.portalId,
			},
      onClick: onShowPopup
    }, null, 8, ["size", "ga"]),
    _createVNode(_Transition, {
      "enter-active-class": "duration-200 ease-out",
      "enter-from-class": "transform opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-100 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "transform opacity-0"
    }, {
      default: _withCtx(() => [
        (showPopup.value)
          ? (_openBlock(), _createBlock(PopupHubspot, {
              key: 0,
              "portal-id": __props.portalId,
              "form-id": __props.formId,
              "pre-populated-fields": __props.prePopulatedFields,
              onClose: onHidePopup
            }, null, 8, ["portal-id", "form-id", "pre-populated-fields"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})